export default {
  getProduct(state) {
    return state.product;
  },
  getProducts: (state) => state.products,
  getPage: (state) => state.page,
  getTotalPage: (state) => state.totalPage
};
